<div class="moti-chat-dialog">
  <div class="moti-chat-header">
    <h2>{{ objectName }}</h2>
    @if (objectType === ObjectType.TILE || objectType === ObjectType.DEVICE || objectType === ObjectType.HUB) {
      <motn-pill
        [squareLetter]="objectType === ObjectType.TILE ? 't' : objectType === ObjectType.DEVICE ? 'd' : 'h'"
      >{{ objectId }}</motn-pill>
    }
    <button class="close-button" (click)="closeDialog()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="moti-chat-content">
    @if (displayConvo$ | async; as convo) {
      <moti-convo
        [convo]="convo"
        [canChat]="true"
        (ready)="onConvoReady()"
      ></moti-convo>
    } @else if (isLoading) {
      <div class="loading-container">
        <motn-spinner></motn-spinner>
      </div>
    }
  </div>
</div>